import { takeEvery } from 'redux-saga/effects';
import { WS_CONNECTION, WS_DISCONNECTION } from '../actions';
import { AUTHORIZED_MODULE, WEB_SOCKET_MODULE } from '../../../configs/moduleNames';
import { AUTHORIZED_CHECK } from '../../Authorized/actions';
import { SUCCESSFUL } from '../../../configs/actionNames';

import wsConnection from './wsConnection';
import wsDisconnection from './wsDisconnection';

export default function* watchSystem() {
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_CHECK + SUCCESSFUL, wsConnection);
  // yield takeEvery(WEB_SOCKET_MODULE + WS_CONNECTION, wsConnection);
  yield takeEvery(WEB_SOCKET_MODULE + WS_DISCONNECTION, wsDisconnection);
}
